import styled from 'styled-components';
import { MARGIN, PADDING, REBRAND_COLOR, REBRAND_GRADIENT } from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background: ${REBRAND_GRADIENT.SKYWARD_BLUE};
`;

export const StyledHeroBrandedContainer = styled(Section)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: ${PADDING.P64};
  padding-bottom: ${PADDING.P64};
  text-align: center;
`;

export const StyledAppStoreBadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${PADDING.P64};
  a:not(:last-child) {
    margin-right: ${MARGIN.M16} !important;
  }
`;
